import type { Tokens } from '../augmentation'
import { type ComponentCreation } from './types'

export const createMuiFormControl = ({ palette }: Pick<Tokens, 'palette'>) =>
  ({
    MuiFormControl: {
      styleOverrides: {
        // TODO: WHY? dense currently is for margin attribute why do we reset this?
        // did we mean to introduce a new component?
        marginDense: {
          marginTop: 0,
          marginBottom: 0,
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          marginLeft: 0,
        },
        label: {
          '&.Mui-disabled': {
            color: palette.action.disabled,
          },
        },
        asterisk: {
          color: palette.error.main,
        },
      },
    },
  }) satisfies ComponentCreation
